<template>
  <div class="chatbot-box">
    <div class="chat-header">
      🤖 Tư vấn sản phẩm
      <span class="close" @click="$emit('close')">✖</span>
    </div>

    <div class="chat-body" ref="body">
      <div v-for="(m, i) in messages" :key="i" :class="['msg', m.from]">
        <div class="bubble">
          <div v-if="m.type === 'text'">{{ m.text }}</div>

          <div v-if="m.type === 'product'" class="product" @click="onClickProduct" style="cursor: pointer;" >
            <div class="d-flex flex-column"> 
              <div class="d-flex">
            <img v-if="getImages(m.product).length" :src="getImages(m.product)[0]" />
            <div style="margin: auto;">
              <b>{{ m.product.name }}</b>
              <div class="price">
                {{ m.product.price > 0
                  ? formatPrice(m.product.price) + '₫'
                  : 'Liên hệ'
                }}
              </div>
              </div>
            </div>
            <div class="product-dec mt-3"> <span> {{ m.product.description  }} </span> </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<div
  class="suggestions"
  v-if="filteredSuggestions.length"
>
  <button
    v-for="(s, i) in filteredSuggestions"
    :key="i"
    @click="selectSuggestion(s)"
  >
    {{ s }}
  </button>
</div>
    <div class="chat-input">
      <input v-model="input" @keyup.enter="send" placeholder="Nhập tên sản phẩm..." />
      <button @click="send">Gửi</button>
    </div>
  </div>
</template>

<script>

// import { get } from 'lodash';

export default {
  props: ["products"],
  data() {
    return {
      input: "",
      typing: false,
        isFirstTime: true,
      suggestions: [
      "VSound",
      "Mini",
      "VPalm",
      "VPhone","VTablet",
      "VSpeaker",
      "Wifi 4G", "Thẻ"
    ],
      messages: [
        {
          from: "bot",
          type: "text",
          text: "Xin chào 👋 Bạn muốn tìm sản phẩm gì hôm nay?"
        }
      ]
      
    };
  },
  computed: {
  filteredSuggestions() {
    if (this.isFirstTime) return this.suggestions;

    if (!this.input) return [];

    const key = this.normalize(this.input);

    return this.suggestions.filter(s =>
      this.normalize(s).includes(key)
    );
  },
  },
   methods: {
    onClickProduct(){
    
    // window.location.href = '/thietbithietyeu';
    },
  selectSuggestion(text) {
    this.isFirstTime = false;
    this.input = text;
    this.send();
  },
    getImages(p) {
      const imgs = p.image || "";
      return imgs ? imgs.split(";") : [];
    },
    send() {
      if (!this.input.trim()) return;
this.isFirstTime = false;
      const userText = this.input;
      const keyword = this.normalize(userText);

      this.messages.push({
        from: "user",
        type: "text",
        text: userText
      });

      this.input = "";
      this.scrollBottom();

      this.botTyping(() => {
        const results = this.smartSearch(keyword);

        if (results.length === 0) {
          this.messages.push({
            from: "bot",
            type: "text",
            text: "😥 Mình chưa tìm thấy sản phẩm phù hợp. Bạn thử mô tả rõ hơn nhé!"
          });
        } else {
          this.messages.push({
            from: "bot",
            type: "text",
            text:
              results.length > 1
                ? "🔍 Mình tìm được vài sản phẩm phù hợp:"
                : "🎯 Đây là sản phẩm bạn đang tìm:"
          });

          results.forEach(p => {
            this.messages.push({
              from: "bot",
              type: "product",
              product: p
            });
          });

          if (results.length >= 3) {
            this.messages.push({
              from: "bot",
              type: "text",
              text: "👉 Bạn thích mẫu nào hay cần lọc theo giá?"
            });
          }
        }

        this.scrollBottom();
      });
    },

    /* ================= SMART SEARCH ================= */
    smartSearch(keyword) {
      const keys = keyword.split(" ");

      return this.products
        .map(p => {
          const name = this.normalize(p.name);
          let score = 0;

          keys.forEach(k => {
            if (name.includes(k)) score += 1;
          });

          return { ...p, score };
        })
        .filter(p => p.score > 0)
        .sort((a, b) => b.score - a.score)
        .slice(0, 3); // chỉ lấy top 3
    },

    /* ================= BOT TYPING ================= */
    botTyping(callback) {
      this.typing = true;
      this.messages.push({
        from: "bot",
        type: "text",
        text: "🤖 Đang tìm sản phẩm..."
      });

      setTimeout(() => {
        this.messages.pop(); // remove typing
        this.typing = false;
        callback();
      }, 800 + Math.random() * 600);
    },

    /* ================= UTILS ================= */
    normalize(str) {
      return str
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },

    formatPrice(v) {
      return v.toLocaleString("vi-VN");
    },

    scrollBottom() {
      this.$nextTick(() => {
        this.$refs.body.scrollTop = this.$refs.body.scrollHeight;
      });
    }
  }
};


</script>

<style scoped>
.chatbot-box {
  width: 380px;
  height: 420px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, .2);
  display: flex;
  flex-direction: column;
}
.suggestions {
  display: flex;
  gap: 8px;
  padding: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}

/* Ẩn scrollbar (tuỳ chọn) */
.suggestions::-webkit-scrollbar {
  height: 4px;
}

.suggestions::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

/* Button */
.suggestions button {
  flex: 0 0 auto;
  border: 1px solid #047a9a;
  background: #e8f6fa;
  color: #047a9a;
  padding: 6px 12px;
  border-radius: 18px;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
}

.suggestions button:hover {
  background: #047a9a;
  color: #fff;
}
.chat-header {
  background: #047a9a;
  color: #fff;
  padding: 10px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.close {
  cursor: pointer;
}

.chat-body {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
  background: #f5f5f5;
}

.msg {
  margin-bottom: 8px;
}

.msg.user {
  text-align: right;
}

.bubble {
  display: inline-block;
  background: #fff;
  padding: 8px;
  border-radius: 10px;
  max-width: 90%;
}

.msg.user .bubble {
  background: #d1e7ff;
}

.product {
  display: flex;
  gap: 8px;
}

.product img {
  width: 50px;
  height: 50px;
  object-fit: contain;
}

.price {
  color: #047a9a;
  font-weight: 600;
}

.chat-input {
  display: flex;
  border-top: 1px solid #ddd;
}

.chat-input input {
  flex: 1;
  border: none;
  padding: 8px;
}

.chat-input button {
  border: none;
  background: #047a9a;
  color: #fff;
  padding: 0 12px;
}
.product-dec{
   white-space: pre-line;
  font-size: 13px;
  line-height: 1.5;
}
.msg.bot .bubble {
  background: #ffffff;
  animation: fadeIn 0.3s ease;
}

.msg.user .bubble {
  background: #ee4d2d;
  color: #fff;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
